module.exports = require("@blueprintjs/core");